import { render, staticRenderFns } from "./Pagibig.vue?vue&type=template&id=3205254e&scoped=true"
import script from "./Pagibig.vue?vue&type=script&lang=js"
export * from "./Pagibig.vue?vue&type=script&lang=js"
import style0 from "./Pagibig.vue?vue&type=style&index=0&id=3205254e&prod&lang=css&scoped=true"
import style1 from "./Pagibig.vue?vue&type=style&index=1&id=3205254e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3205254e",
  null
  
)

export default component.exports